import * as React from "react";
import { experiences } from "../data/portfolioData";
import calendarimg from "../assets/img/calander.png";

const ExperienceSection = () => {
  return (
    <div className="experience-timeline">
      <div className="timeline-line" aria-hidden="true" />
      {experiences.map((experience, index) => (
        <article
          key={`${experience.companyName}-${experience.role}`}
          className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
        >
          <div className="timeline-dot" aria-hidden="true" />
          <div className="timeline-card">
            <img
              src={experience.companyImage}
              alt={`${experience.companyName} logo`}
              className="timeline-logo"
              loading="lazy"
              decoding="async"
            />
            <div className="timeline-content">
              <h3 className="timeline-role">{experience.role}</h3>
              <p className="timeline-company">{experience.companyName}</p>
              <p className="timeline-duration">
                <img
                  className="job-duration-img"
                  src={calendarimg}
                  alt="Calendar icon"
                  loading="lazy"
                  decoding="async"
                />
                {experience.jobDuration}
              </p>
            </div>
          </div>
        </article>
      ))}
    </div>
  );
};

export default ExperienceSection;
